<template>
  <div id="app" v-wechat-title="$route.meta.title">
    <Header v-if="$route.meta.hasHeader"></Header>
    <div class="wrapper">
      <router-view/>
    </div>
    <Footer v-if="$route.meta.hasFooter"></Footer>
  </div>
</template>

<script>
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';

export default {
  name: 'App',
  components:{Footer,Header}
}
</script>

<style>
html,body{
  height: 100%;
}
ul{
    padding: 0;
    list-style: none;
}
.wrapper {
  flex: 1;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  min-height: 100%;
}
/*chrome滚动条样式*/
::-webkit-scrollbar {
  height: 8px;
  width: 8px;
  background: rgba(222, 222, 222, 0.5);
  transition: all 0.3s ease-in-out;
  border-radius: 5px;
}

::-webkit-scrollbar-button {
  display: none;
}

::-webkit-scrollbar-track {
  background-color: #fff;
}

::-webkit-scrollbar-track-piece {
  background: #fff;
}

::-webkit-scrollbar-thumb {
  width: 8px;
  min-height: 15px;
  background: rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease-in-out;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.6);
}

::-webkit-scrollbar-thumb:active {
  background: rgba(0, 0, 0, 0.8);
}


/* * {
    background: #000 !important;
    color: #0f0 !important;
    outline: solid #f00 1px !important;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue